/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { GENERATE_TOOLBAR_FIELDS, SET_TOOLBAR_VALUE } from '../actions/toolbar';
import type { ToolbarAction, ToolbarState } from '../types/toolbar';

export const initialState: ToolbarState = {};

export const toolbarReducer = (state: ToolbarState, action: ToolbarAction): ToolbarState => {
    switch (action.type) {
        case GENERATE_TOOLBAR_FIELDS:
            return {
                ...state,
                [action.payload.name]: action.payload.value,
            };
        case SET_TOOLBAR_VALUE:
            return {
                ...state,
                [action.payload.name]: {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    ...state[action.payload.name],
                    [action.payload.fieldName]: action.payload.fieldValue,
                },
            };
        default:
            return state;
    }
};
